function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import lodashIsString from 'lodash/isString';
import EBPropTypes from 'js-utils/prop-types';
import Button from '../button/Button';
import ListItem from '../listItem/ListItem';
import { VERTICAL_ALIGNMENTS_PROP_TYPE } from '../listItem/constants';
import MoreActions from '../moreActions/MoreActions';
import { TEXT_ITEMS_PROP_TYPE } from '../textList/constants';
import { ICON_TYPE_PROP_TYPE, ICON_SIZE_PROP_TYPE, COLOR_PROP_TYPE } from '../icon/constants';

var _getMoreActions = function _getMoreActions(moreActionItems, onAction) {
  var isMoreActionDisabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // Remove component if items are not provided
  if (!moreActionItems) {
    return null;
  }

  var moreActionsClass = classNames('eds-g-cell', 'eds-g-cell--has-overflow', 'eds-g-cell-1-12');
  var moreActions; // Leave wrapper but exclude component when items are empty

  if (!isEmpty(moreActionItems)) {
    moreActions = React.createElement(MoreActions, {
      items: moreActionItems,
      onAction: onAction,
      align: "right",
      isDisabled: isMoreActionDisabled
    });
  }

  return React.createElement("div", {
    className: moreActionsClass,
    "data-spec": "edit-list-item-more-actions-bar"
  }, React.createElement("div", {
    className: "eds-text--right"
  }, moreActions));
};

var EditListItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(EditListItem, _PureComponent);

  function EditListItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, EditListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EditListItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getMainContent", function () {
      var _this$props = _this.props,
          content = _this$props.content,
          secondaryContent = _this$props.secondaryContent,
          tertiaryContent = _this$props.tertiaryContent,
          noWrap = _this$props.noWrap,
          actionItems = _this$props.actionItems,
          extraContent = _this$props.extraContent,
          iconType = _this$props.iconType,
          iconSize = _this$props.iconSize,
          iconColor = _this$props.iconColor,
          imageUrl = _this$props.imageUrl,
          imageAlt = _this$props.imageAlt,
          isSquareImage = _this$props.isSquareImage,
          isSelected = _this$props.isSelected,
          isTentativelySelected = _this$props.isTentativelySelected,
          useAltTheme = _this$props.useAltTheme,
          isDisabled = _this$props.isDisabled,
          verticalAlignment = _this$props.verticalAlignment,
          children = _this$props.children;
      var contentClass = classNames('eds-list-item-content', 'eds-align--left', 'eds-align--mn-right', 'eds-align--md-right', 'eds-align--mw-right', 'eds-align--ln-right', 'eds-align--lg-right', 'eds-align--lw-right');
      var contentBarGridClass = classNames(actionItems && !noWrap ? 'eds-g-cell-12-12' : 'eds-g-cell-7-12', 'eds-g-cell-mn-7-12', 'eds-g-cell-md-7-12', 'eds-g-cell-mw-7-12', 'eds-g-cell-ln-7-12', 'eds-g-cell-lg-7-12', 'eds-g-cell-lw-7-12');
      var contentBarClass = classNames('edit-list-item__content-bar', 'eds-text-bs', 'eds-text-color--grey-600', 'eds-l-sn-mar-bot-1', 'eds-l-sm-mar-bot-1', 'eds-l-sw-mar-bot-1');
      var actionsBarGridClass = classNames(actionItems && !noWrap ? 'eds-g-cell-12-12' : 'eds-g-cell-5-12', 'eds-g-cell-mn-5-12', 'eds-g-cell-md-5-12', 'eds-g-cell-mw-5-12', 'eds-g-cell-ln-5-12', 'eds-g-cell-lg-5-12', 'eds-g-cell-lw-5-12');
      var actionsBarClass = classNames('edit-list-item__action-bar', actionItems ? 'edit-list-item--column' : 'edit-list-item--row', 'eds-align--left', 'eds-align--mn-right', 'eds-align--md-right', 'eds-align--mw-right', 'eds-align--ln-right', 'eds-align--lg-right', 'eds-align--lw-right', 'eds-text-bm', 'eds-text-color--grey-900');
      var primaryContent = content; // Customize primary content display when string is passed

      if (lodashIsString(content)) {
        primaryContent = React.createElement("p", {
          className: "eds-text-bm eds-text-color--grey-900"
        }, content);
      }

      return React.createElement("div", {
        className: "eds-g-group"
      }, React.createElement("div", {
        className: contentClass
      }, React.createElement("div", {
        className: contentBarGridClass
      }, React.createElement("div", {
        className: contentBarClass,
        "data-spec": "edit-list-item-content-bar"
      }, React.createElement(ListItem, {
        "data-spec": "edit-list-item",
        extraContent: extraContent,
        iconType: iconType,
        iconSize: iconSize,
        iconColor: iconColor,
        imageUrl: imageUrl,
        imageAlt: imageAlt,
        isSquareImage: isSquareImage,
        isSelected: isSelected,
        isTentativelySelected: isTentativelySelected,
        useAltTheme: useAltTheme,
        isDisabled: isDisabled,
        verticalAlignment: verticalAlignment
      }, primaryContent, secondaryContent, tertiaryContent))), React.createElement("div", {
        className: actionsBarGridClass
      }, React.createElement("div", {
        className: actionsBarClass,
        "data-spec": "edit-list-item-action-bar"
      }, children))));
    });

    return _this;
  }

  _createClass(EditListItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          actionItems = _this$props2.actionItems,
          onAction = _this$props2.onAction,
          isTentativelySelected = _this$props2.isTentativelySelected,
          isSelected = _this$props2.isSelected,
          useAltTheme = _this$props2.useAltTheme,
          isDisabled = _this$props2.isDisabled,
          verticalAlignment = _this$props2.verticalAlignment,
          onClick = _this$props2.onClick,
          href = _this$props2.href,
          __containerClassName = _this$props2.__containerClassName,
          isMoreActionDisabled = _this$props2.isMoreActionDisabled;
      var editCardClassNames = classNames('eds-g-group', 'eds-list-item', 'edit-list-item', 'eds-align--space-between', 'eds-l-pad-all-4', 'eds-l-mn-pad-hor-6', 'eds-l-md-pad-hor-6', 'eds-l-mw-pad-hor-6', 'eds-l-ln-pad-hor-6', 'eds-l-lg-pad-hor-6', 'eds-l-lw-pad-hor-6', __containerClassName, _defineProperty({
        'eds-list-item--selected': isSelected,
        'eds-list-item--tentatively-selected': isTentativelySelected,
        'eds-list-item--alt-theme': useAltTheme,
        'eds-list-item--disabled': isDisabled
      }, "eds-list-item--align-".concat(verticalAlignment), verticalAlignment));
      var contentGridClass = classNames(actionItems && !onClick ? 'eds-g-cell-11-12' : 'eds-g-cell-12-12');
      var mainContent = this.getMainContent();
      var shouldWrapContentWithButton = !isDisabled && (onClick || href);

      if (shouldWrapContentWithButton) {
        var buttonType = href ? 'link' : 'button';
        mainContent = React.createElement(Button, {
          type: buttonType,
          href: href,
          onClick: onClick,
          style: "none",
          size: "block",
          "data-spec": "edit-list-item-button"
        }, mainContent);
      }

      return React.createElement("div", {
        className: editCardClassNames,
        "data-spec": "edit-list-item"
      }, React.createElement("div", {
        className: contentGridClass
      }, mainContent), _getMoreActions(actionItems, onAction, isMoreActionDisabled));
    }
  }]);

  return EditListItem;
}(PureComponent);

_defineProperty(EditListItem, "propTypes", {
  /**
   * Action items
   */
  actionItems: TEXT_ITEMS_PROP_TYPE,

  /**
   * Any child nodes to be displayed that should not have the content styling
   */
  children: PropTypes.node,

  /**
   * The primary content to be displayed
   */
  content: PropTypes.node,

  /**
   * Generic content for the left side
   */
  extraContent: PropTypes.node,

  /**
   * Icon to include in the list item that when specified will wrap the `children` to include the icon
   */
  iconType: ICON_TYPE_PROP_TYPE,

  /**
   * Size of included icon
   */
  iconSize: ICON_SIZE_PROP_TYPE,

  /**
   * Color of included icon
   */
  iconColor: COLOR_PROP_TYPE,

  /**
   * URL of image to be displayed with list item content
   */
  imageUrl: PropTypes.string,

  /**
   * Alt text for image to be displayed with list item content
   */
  imageAlt: EBPropTypes.translation,

  /**
   * Option for image in list item to be square shaped
   */
  isSquareImage: PropTypes.bool,

  /**
  * Callback function that will be called when a action item is selected
  * (value, index) => {}
  **/
  onAction: PropTypes.func,

  /**
  * State of card being selected
  **/
  isSelected: PropTypes.bool,

  /**
   * The secondary content to be displayed
   */
  secondaryContent: PropTypes.node,

  /**
   * The tertiary content to be displayed
   */
  tertiaryContent: PropTypes.node,

  /**
   * Verical Alignment on item
   */
  verticalAlignment: VERTICAL_ALIGNMENTS_PROP_TYPE,

  /**
   * Whether or not the text list item is tenatively selected.
   * This comes into play on hover or via arrow key press before an
   * actual selection is made
   */
  isTentativelySelected: PropTypes.bool,

  /**
   * Whether or not the item should use an alternate theme
   */
  useAltTheme: PropTypes.bool,

  /**
   * Whether or not the item is disabled
   */
  isDisabled: PropTypes.bool,

  /**
   * Handler of clicking on content
   */
  onClick: PropTypes.func,

  /**
   * URL to link content to
   */
  href: PropTypes.string,

  /**
   * An option to prevent column wrapping (preserve columns) on all sizes of
   * small screens if actionItems are present.
   */
  noWrap: PropTypes.bool,

  /**
   * Custom container class
   */
  __containerClassName: PropTypes.string,

  /**
   * Whether or not the more action options are disabled
   */
  isMoreActionDisabled: PropTypes.bool
});

_defineProperty(EditListItem, "defaultProps", {
  noWrap: false,
  isMoreActionDisabled: false
});

export { EditListItem as default };